import { Drawer, Spin, Alert, Table, Select } from 'antd';
import React, { useEffect, useMemo, useState } from 'react';

import { useGetMpCatalogues } from '../../../../utils/api/mpCatalogue/useGetMpCatalogue';

const PreviewDrawer = ({
  open,
  onClose,
  onReferenceChange,
  store,
  mp_category,
  data,
  isLoading,
  error,
}) => {
  const tableData = useMemo(() => {
    if (!data?.mapped_product) return [];

    return Object.entries(data.mapped_product).map(([key, content]) => ({
      key,
      attribute: key,
      value:
        typeof content.value === 'object'
          ? JSON.stringify(content.value)
          : String(content.value),
      label:
        typeof content.label === 'object'
          ? JSON.stringify(content.label)
          : String(content.label),
    }));
  }, [data]);

  const [searchedReference, setSearchedReference] = useState('');
  const [debouncedSearch, setDebouncedSearch] = useState('');

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(searchedReference.trim());
    }, 300);
    return () => clearTimeout(timer);
  }, [searchedReference]);

  const { mpCatalogues, isLoading: isCataloguesLoading } = useGetMpCatalogues(
    {
      search: debouncedSearch,
      store: store?.id,
      mp_category: mp_category?.id,
      limit: 50,
    },
    {
      enabled: !!store?.id && !!mp_category?.id,
    }
  );

  const productOptions = useMemo(() => {
    if (isCataloguesLoading || !Array.isArray(mpCatalogues)) return [];

    return mpCatalogues
      .filter((p) => p?.product?.reference)
      .map((p) => ({
        value: p.product.reference,
        label: `${p.product.reference} ${p?.product?.name || ''}`.trim(),
      }));
  }, [mpCatalogues, isCataloguesLoading]);

  const selectedReference = data?.reference || undefined;

  const columns = [
    {
      title: 'Attribut',
      dataIndex: 'attribute',
      key: 'attribute',
      width: 300,
    },
    {
      title: 'Valeur',
      dataIndex: 'value',
      key: 'value',
      ellipsis: true,
    },
    {
      title: 'Label',
      dataIndex: 'label',
      key: 'label',
      ellipsis: true,
    },
  ];
  return (
    <Drawer
      title="Prévisualisation du mapping"
      placement="right"
      width="calc(100vw - 220px)"
      open={open}
      onClose={onClose}
    >
      <Select
        showSearch
        loading={isCataloguesLoading}
        placeholder="Référence du produit"
        options={productOptions}
        value={selectedReference}
        searchValue={searchedReference}
        onSearch={setSearchedReference}
        onChange={onReferenceChange}
        style={{ width: '100%', marginBottom: '20px' }}
        filterOption={false}
      />

      {isLoading && <Spin tip="Chargement..." />}

      {error && (
        <Alert
          type="error"
          message="Erreur"
          description={error?.message || 'Une erreur est survenue'}
          showIcon
        />
      )}

      {data && !isLoading && (
        <Table
          columns={columns}
          dataSource={tableData}
          pagination={false}
          size="small"
          bordered
          scroll={{ y: 'calc(100vh - 350px)' }}
        />
      )}
    </Drawer>
  );
};

export default PreviewDrawer;
